var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBolt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.82009 13.1248C5.67978 13.2866 5.79478 13.5385 6.00901 13.5385H10.4694C10.6337 13.5385 10.7533 13.6942 10.711 13.8529L8.81765 20.953C8.74932 21.2092 9.07445 21.3816 9.24813 21.1812L18.1799 10.8753C18.3202 10.7134 18.2052 10.4616 17.991 10.4616H13.5305C13.3663 10.4616 13.2466 10.3059 13.289 10.1471L15.1823 3.04704C15.2506 2.79081 14.9255 2.6185 14.7518 2.81889L5.82009 13.1248ZM15.1575 8.96156L16.6317 3.43354C17.11 1.63992 14.8341 0.433708 13.6183 1.8365L4.68655 12.1424C3.7044 13.2756 4.5094 15.0385 6.00901 15.0385H8.84244L7.36829 20.5665C6.89 22.3601 9.16591 23.5663 10.3817 22.1636L19.3134 11.8577C20.2956 10.7244 19.4906 8.96156 17.991 8.96156H15.1575Z",
    className: "Icon-fill-color"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBolt);
export default __webpack_public_path__ + "static/media/Bolt.a513cbb72c9ddb74943dc709e1010016.svg";
export { ForwardRef as ReactComponent };